document.addEventListener('alpine:init', () => {
    Alpine.store('teamOnboarding', {
        shouldShowAddTeamDialog: false,
        newTeamName: '',
        userHasChangedNewTeamName: false,

        showAddTeamDialog(newTeamNameSuggestion) {
            this.shouldShowAddTeamDialog = true;
            document.body.style.overflow = 'hidden';

            if (! this.userHasChangedNewTeamName) {
                this.newTeamName = newTeamNameSuggestion;
            }
        },

        hideAddTeamDialog() {
            this.shouldShowAddTeamDialog = false;
            document.body.style.overflow = 'auto';
        },

        setNewTeamName(name) {
            this.newTeamName = name;
            this.userHasChangedNewTeamName = true;
        }
    })
})
